import { Table } from "react-bootstrap";
import "./style.scss";

export default function ReportTable({ data = [], headers = [[]] }) {
  return (
    <Table className="report-table" responsive borderless>
      <thead>
        {headers.flat().length > 0 &&
          headers.map((_, i) => (
            <tr key={i}>
              {_.map((text) => (
                <th key={text}>{text}</th>
              ))}
            </tr>
          ))}
      </thead>
      <tbody>
        {data.map((arr, i) => (
          <tr key={i}>
            {arr.map((_, index) => (
              <td key={`key${i}${index}`}>{_}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
